/**
 * @generated SignedSource<<fb1b6b590b5ea69c67d6eaf16cbdad2a>>
 * @relayHash 3746bdb44c8e624e3638a3c46fa28355
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID f5b90daa3e238d64cfb8b2f06745a24ab11f5773fb081ebcd045a7fc1df2b163

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { LiveConversationsAppQuery } from './LiveConversationsAppQuery.graphql';

const node: PreloadableConcreteRequest<LiveConversationsAppQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "f5b90daa3e238d64cfb8b2f06745a24ab11f5773fb081ebcd045a7fc1df2b163",
    "metadata": {},
    "name": "LiveConversationsAppQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
